type Context = 'partner-connections';

type Section = 'fetch';

type Value = `${Context}-${Section}`;

export const Keys: Record<Section, Value> = {
  fetch: 'partner-connections-fetch',
};
